import React from 'react';
import {openV1PopupInfo} from '../../../../../emitters/popup';
import {
  TRANSACTION_STATUS_DESCRIPTION_MAP,
  TRANSACTION_STATUS_TITLE_MAP,
} from './../constants';
import toEllipsisMiddle from '../../../../../utils/toEllipsisMiddle';
import formatTime, {getRFC3339} from 'mn-utils/formatTime';
import Tooltip from '../../../../dumb/Tooltip/A';
import Ripple from '../../../../dumb/Ripple';
import InfoIcon from '../../../../icons/Info';
import TransactionInfoPage from './TransactionInfoPage';

const columnDateTime = (datetime) => {
  const title = getRFC3339(datetime);
  const date = formatTime(datetime, '{dd} {mmm}, {yyyy}');
  const time = formatTime(datetime, '{hh}:{MM}:{ss} {TT}');

  return (
    <Tooltip className="mA>1" title={title}>
      <div className="lh15">{date}</div>
      <div className="c717275 fw4 lh15 mt5">
        {time}
      </div>
    </Tooltip>
  );
};

module.exports = (props) => {
  const transactions = props.transactions || [];

  return (
    <section className={props.className || ''}>
      <div className="dTB">
        <div className="dTableCaption f22 tc cA4A7AC">Transactions</div>
        <div className="dTBHG bb2 bcbC.2 bsb dTBR>1 (dTBC|pv10|ph15|cA4A7AC|f16|fw5|tc)>1>1">
          <div>
            <div>ID</div>
            <div>TX number</div>
            <div className="w210">Status</div>
            <div className="w130">Created at</div>
            <div className="w130">Updated at</div>
            <div className="w50" />
          </div>
        </div>

        <div className="dTBRG f14">
          {transactions.sort((t1, t2) => {
            return new Date(t2.created_at) - new Date(t1.created_at);
          }).map((transaction) => {
            const icon = (<InfoIcon className="dB-i f46-i mhA w50 h50"/>);
            const info = (<div className="f22">Transaction details</div>);
            const msg = (<TransactionInfoPage transaction={transaction}/>);

            return (
              <div key={transaction.id} className="dTBR vaM (dTBC|pv10|ph15|vaM)>1 bgF.03:h">
                <div>
                  <Tooltip title={transaction.id}>
                    {toEllipsisMiddle(transaction.id, 16)}
                  </Tooltip>
                </div>
                <div>
                  <Tooltip title={transaction.tx_number}>
                    {transaction.tx_number}
                  </Tooltip>
                </div>
                <div>
                  <Tooltip
                    className="mA>1"
                    title={TRANSACTION_STATUS_DESCRIPTION_MAP[transaction.status]}
                    disabledCopy
                  >
                    {TRANSACTION_STATUS_TITLE_MAP[transaction.status]}
                  </Tooltip>
                </div>
                <div>{columnDateTime(transaction.created_at)}</div>
                <div>{columnDateTime(transaction.updated_at)}</div>
                <div>
                  <Tooltip title="Transaction info" disabledCopy>
                    <Ripple
                      className="w42 h42 p7 r7 (bgc0.25):h"
                      onClick={() => {
                        openV1PopupInfo([info, msg, icon]);
                      }}
                    >
                      <InfoIcon/>
                    </Ripple>
                  </Tooltip>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
